import { LocationApi } from '../api/apicollection';

export default function OverlayImageViewModel() {
    this.logoUrl = ko.observable();

    this.Load = () => {
        LocationApi.getLocationLogo().then(data => {
            this.logoUrl(data.data);
        });
        let backgroundImage = document.getElementById("ImageUrl").value;

        document.getElementById('overlayImageVM').style.backgroundImage = `linear-gradient(to bottom, rgba(0, 0, 0, 0.49) 0%, rgba(0, 0, 0, 0.49) 100%),url(${backgroundImage})`;
    };
    this.Load()
    return this;
};